import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let ViewDocumentModalComponent = {
    selector: "vcViewDocument",
    templateUrl:
        "/angular/components/document/view-document-modal.component.html",
    bindings: {
        document: "=?",
    },
    controller: class ViewDocumentModalController {
        // * bindings for typescript compiler *
        public document?: any;
        // ************************************

        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("document")
    .component(ViewDocumentModalComponent.selector, ViewDocumentModalComponent);
